<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'StepReject',
})
</script>
<template>
  <TlDetailItem title="驳回" color="red">
    <TlDetailField label="审核人">{{ record?.createAdminUserObj?.loginName }}</TlDetailField>
    <TlDetailField label="审核时间">{{ record?.createdAt }}</TlDetailField>
    <TlDetailField label="审核意见">{{ record?.shenHeYiJian }}</TlDetailField>
    <TlDetailField label="监审组提供的整改清单" v-if="fileVisible">
      <FileDisplayNormals :files="jianShenQingDanFiles" :colAttrs="{ span: 12 }" />
    </TlDetailField>
  </TlDetailItem>
</template>

<script lang="ts" setup name="StepReject">
import { computed } from 'vue'
import { FileDisplayNormals } from '-/Common/FileDisplay'
import TlDetailField from './TlDetailField.vue'
import TlDetailItem from './TlDetailItem.vue'
const props = withDefaults(
  defineProps<{
    record?: Record<string, any>
    fileVisible?: boolean
    title?: string
  }>(),
  {
    fileVisible: true,
    title: '驳回'
  }
)
// 监审组提供的整改清单
const jianShenQingDanFiles = computed(() => props.record?.files?.jianShenQingDanFiles ?? [])
</script>
